import "./Card.css";

const Card = ({ titleservice, description, image }) => {
  const goToWhatsapp = (numero, mensaje) => {
    const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="w-70 p-4 bg-slate-50 rounded-lg shadow-md transform hover:scale-105 transition-transform duration-300 ease-in-out">
      <img
        alt={titleservice}
        src={image}
        className="w-full h-40 object-cover rounded-t-lg"
      />
      <div className="p-4">
        <h2 className="text-xl  font-semibold">{titleservice}</h2>
        <p className="text-gray-600">{description}</p>
        <div className="flex justify-between items-center mt-4">
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-400"
            onClick={() =>
              goToWhatsapp(
                "5493416697243",
                `Hola, quiero consultar por ${titleservice}`,
              )
            }
          >
            Consultar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Card;
